import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/algolia': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M229.3 182.6C180 182.6 140.1 222.5 140.1 271.8 140.1 321.1 180 361 229.3 361S318.5 321.1 318.5 271.8C318.5 222.5 278.5 182.6 229.3 182.6zM292 239.2L233.1 269.8C231.3 270.7 229.3 269.4 229.3 267.5V201C229.3 199.5 230.6 198.3 232 198.4 258.2 199.4 280.9 214.1 293.1 235.5 293.8 236.8 293.3 238.5 292 239.2zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421C0 453.6 26.4 480 58.9 480H389C421.6 480 447.9 453.6 447.9 421.1V90.9C448 58.4 421.6 32 389.1 32zM186.5 116.7C186.5 105.9 195.2 97.2 206 97.2H251.3C262.1 97.2 270.8 105.9 270.8 116.7V132.1C270.8 133.9 269.1 135.1 267.5 134.6 255.2 131.2 242.4 129.5 229.4 129.5 215.9 129.5 202.7 131.3 190 135 188.3 135.5 186.6 134.2 186.6 132.5V116.7zM102.1 153.7L111.3 144.5C118.9 136.9 131.2 136.9 138.8 144.5L146.5 152.2C147.6 153.3 147.5 155.2 146.2 156.2 140 160.7 134.1 165.6 128.6 171.1 123.2 176.5 118.2 182.4 113.8 188.5 112.8 189.8 110.9 190 109.8 188.8L102.1 181.1C94.5 173.6 94.5 161.3 102.1 153.7zM229.3 398.5C159.3 398.5 102.7 341.8 102.7 271.9S159.4 145.3 229.3 145.3C299.3 145.3 355.9 201.9 355.9 271.9 355.9 341.7 299.2 398.5 229.3 398.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/algolia.js
// module id = C4O5
// module chunks = 144